import { DefaultBreakpoints } from '@/theme/defaults/breakpoints'

import { useMediaQuery } from './use-media-query'

// Note: mirrors media.down('sm') exactly (@/theme/common/media.ts) by importing the same
// DefaultBreakpoints.sm rather than hardcoding 600, so this can never drift from the CSS
// breakpoint it's meant to match.
const MOBILE_QUERY = `(max-width: ${DefaultBreakpoints.sm - 1}px)`

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY)
